import React, { useContext, useEffect, createContext } from "react";

// project-imports
import { setCookie } from "../utils";
import {
  getYouTubeData,
  getYouTubeLatestVideo,
  getYouTubeVideoCategories,
} from "./youtube_api_context";
import {
  GET_YOUTUBE_CHANNEL_DATA_BEGIN,
  GET_YOUTUBE_CHANNEL_DATA_FAILURE,
  GET_YOUTUBE_CHANNEL_DATA_SUCCESS,
  GET_YOUTUBE_LATEST_VIDEO_BEGIN,
  GET_YOUTUBE_LATEST_VIDEO_FAILURE,
  GET_YOUTUBE_LATEST_VIDEO_SUCCESS,
  GET_YOUTUBE_VIDEO_CATEGORIES_BEGIN,
  GET_YOUTUBE_VIDEO_CATEGORIES_FAILURE,
  GET_YOUTUBE_VIDEO_CATEGORIES_SUCCESS,
} from "../constants/actions";

// third-party
import { useDispatch, useSelector } from "react-redux";

// default object for the testimonial
const defaultState = {
  ytLoading: false,
  ytError: false,
  ytChannelData: {},
  ytlatestvideo: {},
  ytVideoCategories: {},
};
export const YoutubeContext = createContext();

export const YoutubeProvider = (props) => {

  // Reading store data
  const state = useSelector((state) => state.youtube);

  // Reading dispatch from Store
  const dispatch = useDispatch();

  // Changes for cookie start
  const COOKIE_NAME = "YouTube_Last_Sync_Datetime";
  const expirationLimit = 24 * 60 * 60 * 1000;
  const expirationTime = new Date(Date.now() + expirationLimit);
  const currentTimeInHour = new Date().getHours();

  // Getting YouTube_Last_Sync_Datetime data from cookie
  const ytLastSyncCookie =
    document.cookie
      .match("(^|;)\\s*" + COOKIE_NAME + "\\s*=\\s*([^;]+)")
      ?.pop() || "";

  // Fetching last cookie time
  const ytLastSyncCookieTime = ytLastSyncCookie
    ? ytLastSyncCookie.split(" ") &&
    ytLastSyncCookie.split(" ").length >= 5 &&
    ytLastSyncCookie.split(" ")[4]
    : "";

  // Getting hour from the time
  const ytLastSyncCookieTimeInHour = ytLastSyncCookieTime
    ? ytLastSyncCookieTime.split(":") &&
    ytLastSyncCookieTime.split(":").length > 0 &&
    ytLastSyncCookieTime.split(":")[0]
    : 0;

  useEffect(() => {
    let resetYtCookie = false;

    if (ytLastSyncCookie) {

      // If cookie exist then checking its time difference
      const calculatedTimeDifference = Math.abs(
        currentTimeInHour - ytLastSyncCookieTimeInHour
      );

      // check time difference; if >= 4 then reset cookie
      if (calculatedTimeDifference >= 4) {
        resetYtCookie = true;
      }

    } else {

      // If cookie not exist then reseting the cookie;
      resetYtCookie = true;
    }

    if (resetYtCookie) {
      // reseting the cookie
      setCookie(COOKIE_NAME, Date(), expirationTime);
      fetchYouTubeChannelData();
      fetchYouTubeLatestVideos();
      fetchYouTubeVideoCategories();
    }
  }, []);
  // Changes for cookie End

  // Constant function 

  // Function to get yt channel data
  const fetchYouTubeChannelData = async (domain) => {
    try {

      // Dispatching the action to begin the api calling process
      dispatch({ type: GET_YOUTUBE_CHANNEL_DATA_BEGIN, payload: true });

      // Calling the API to get the YouTubeChannelData
      let response = await getYouTubeData();
      // let response = [];

      // Dispatching the actions on success
      dispatch({ type: GET_YOUTUBE_CHANNEL_DATA_SUCCESS, payload: response });

      // Showing the toast message on getting yt channel data successfully
      // showToast("success", "YouTube channel data fetched successfully ", true, "bottom-right", false, true, 5000);
    } catch (error) {
      console.log("119 : youtube_context : Error while getting youtube channel data::", error && JSON.stringify(error));

      // Dispatching the actions on error
      dispatch({ type: GET_YOUTUBE_CHANNEL_DATA_FAILURE, payload: error && error.message, });
    }
  };

  // Function to get yt latest videos
  const fetchYouTubeLatestVideos = async (domain) => {
    try {

      // Dispatching the action to begin  the api calling process
      dispatch({ type: GET_YOUTUBE_LATEST_VIDEO_BEGIN, payload: true });

      // Calling the API to get the YouTubeLatestVideos
      let response = await getYouTubeLatestVideo();
      // let response = [];

      // Dispatching the actions on success
      dispatch({ type: GET_YOUTUBE_LATEST_VIDEO_SUCCESS, payload: response });

      // Showing the toast message on getting yt latest video successfully
      // showToast("success", "YouTube latest video fetched successfully ", true, "bottom-right", false, true, 5000);
    } catch (error) {
      console.log("119 : youtube_context : Error while getting youtube latest videos::", error && JSON.stringify(error));

      // Dispatching the actions on error
      dispatch({ type: GET_YOUTUBE_LATEST_VIDEO_FAILURE, payload: error && error.message, });
    }
  };

  // Function to get yt video categories 
  const fetchYouTubeVideoCategories = async (domain) => {
    try {

      // Dispatching the action to begin  the api calling process
      dispatch({ type: GET_YOUTUBE_VIDEO_CATEGORIES_BEGIN, payload: true });

      // Calling the API to get the YouTubeVideoCategories
      let response = await getYouTubeVideoCategories();
      // let response = [];

      // Dispatching the actions on success
      dispatch({ type: GET_YOUTUBE_VIDEO_CATEGORIES_SUCCESS, payload: response, });

      // Showing the toast message on getting yt video categories successfully
      // showToast("success", "YouTube video categories fetched successfully ", true, "bottom-right", false, true, 5000);
    } catch (error) {
      console.log("167 : youtube_context : Error while getting youtube video categories::", error && JSON.stringify(error));

      // Dispatching the actions on error
      dispatch({ type: GET_YOUTUBE_VIDEO_CATEGORIES_FAILURE, payload: error && error.message, });
    }
  };

  useEffect(() => {
    localStorage.setItem("youtubeData", JSON.stringify(state));
  }, [state]);

  return (
    <YoutubeContext.Provider
      value={{
        ...state,
        fetchYouTubeChannelData,
        fetchYouTubeLatestVideos,
        fetchYouTubeVideoCategories,
      }}
    >
      {props.children}
    </YoutubeContext.Provider>
  );
};
export const useYoutubeContext = () => {
  return useContext(YoutubeContext);
};
